import { render, staticRenderFns } from "./FTVRequestV2.vue?vue&type=template&id=548dfc78&"
import script from "./FTVRequestV2.vue?vue&type=script&lang=js&"
export * from "./FTVRequestV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports